import * as m from "../../es2015/plugins/venn";
window.am4plugins_venn = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/venn.js
// module id = null
// module chunks = 